// ULID Generator Implementation
// Based on ULID specification: https://github.com/ulid/spec

// Crockford's Base32 alphabet (case insensitive)
const BASE32_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

/**
 * Encodes a timestamp to Base32 (10 characters)
 */
function encodeTimestamp(timestamp: number): string {
  let result = '';
  let time = timestamp;

  for (let i = 0; i < 10; i++) {
    const mod = time % 32;
    result = BASE32_ALPHABET[mod] + result;
    time = Math.floor(time / 32);
  }

  return result;
}

/**
 * Generates random Base32 characters for randomness part (16 characters)
 */
function encodeRandomness(): string {
  let result = '';

  // Generate 16 random Base32 characters
  // Using crypto.getRandomValues for better randomness
  const randomBytes = new Uint8Array(10); // 10 bytes = 80 bits, enough for 16 Base32 chars (80 bits)
  crypto.getRandomValues(randomBytes);

  let bits = 0n;
  for (const byte of randomBytes) {
    bits = (bits << 8n) | BigInt(byte);
  }

  for (let i = 0; i < 16; i++) {
    const index = Number(bits & 31n);
    result = BASE32_ALPHABET[index] + result;
    bits = bits >> 5n;
  }

  return result;
}

/**
 * Generates a new ULID
 */
export function generateULID(): string {
  const timestamp = Date.now();
  const timestampPart = encodeTimestamp(timestamp);
  const randomnessPart = encodeRandomness();

  return timestampPart + randomnessPart;
}
